import React, { useState } from 'react';
import { ModalButton } from '../Button';
import { Modal } from './Modal';
import { NameInput } from '../NameInput';
import { StyledModalError } from '../Styled';
import { COLORS } from '../../constants';
import { isSpacesOnly } from '../../utils';

interface INameNewModal {
  mainColor: string;
  headerText: string;
  value: string;
  setValue: (value: string) => void;
  onButtonClick: (title: string) => void;
  onCloseClick: () => void;
}

export const NameNewModal: React.FC<INameNewModal> = (props): JSX.Element => {
  const { mainColor, headerText, value, setValue, onButtonClick, onCloseClick } = props;

  const [isError, setError] = useState(false);

  const CHARACTERS_NUMBER_LIMIT = 55;

  const isLimitBroken = value.length > CHARACTERS_NUMBER_LIMIT;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setError(false);
    setValue(event.target.value);
  };

  const handleButtonClick = () => {
    if (!value || isSpacesOnly(value)) {
      setError(true);
      return;
    }

    onButtonClick(value);
  };

  return (
    <Modal onCloseClick={onCloseClick} headerText={headerText}>
      {isError && (
        <StyledModalError color={mainColor} data-testid="modal error">
          To save, give your text a title
        </StyledModalError>
      )}
      <NameInput value={value} onChange={handleChange} limit={CHARACTERS_NUMBER_LIMIT} isLimitBroken={isLimitBroken} />
      <ModalButton
        bGColor={mainColor}
        color={COLORS.white}
        text="Save"
        onButtonClick={handleButtonClick}
        isDisabled={isLimitBroken}
      />
    </Modal>
  );
};
